<template>
	<thead v-if="labels != null">
		<tr>
			<th
				v-for="(th, index) in labels"
				:key="index"
				@click="insert_order(th)"
				:title="'Ordenar por ' + th.label"
				:class="me(th.data)"
			>
				<i
					class="fa"
					v-if="me(th.data) != 'NONE'"
					:class="{
						'fa-sort-amount-asc': me(th.data) == 'ASC',
						'fa-sort-amount-desc': me(th.data) == 'DESC',
					}"
				>
				</i>
				{{ th.label }}
			</th>
			<th v-if="actions" class="text-right">Ações</th>
		</tr>
	</thead>
</template>
<script>
	import clone from 'js/clone';

	export default {
		name: 'AppTHeadsTable',
		props: ['value', 'labels', 'actions', 'noOrder'],
		methods: {
			me(data) {
				data = typeof data == 'string' ? data : data[0];
				let index = this.value.findIndex((item) => item.data == data);
				if (index == -1) return 'NONE';
				else return this.value[index].sent;
			},
			insert_order(col) {
				if (col.data != '' && this.noOrder) {
					let old_filter = clone(this.value);
					let data =
						typeof col.data == 'string' ? col.data : col.data[0];
					let index = old_filter.findIndex(
						(item) => item.data == data
					);
					if (index == -1) {
						old_filter.push({ data: data, sent: 'ASC' });
					} else {
						if (old_filter[index].sent == 'ASC') {
							old_filter[index].sent = 'DESC';
						} else {
							old_filter.splice(index, 1);
						}
					}
					this.$emit('input', old_filter);
					this.$emit('updateTable');
				}
			},
		},
	};
</script>
<style scoped>
	th {
		cursor: pointer;
	}
	.ASC,
	.DESC {
		color: #00a65a;
	}
</style>



// WEBPACK FOOTER //
// src/app-components/table/thead.vue